/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1AdType } from '../models/Campaignservicev1AdType';
import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V1State } from '../models/V1State';
import { HttpFile } from '../http/http';

export class V1OrderLineSearch {
    'orderLineId'?: string;
    'name'?: string;
    'refId'?: string;
    'jobId'?: string;
    'poId'?: string;
    'deploymentDestination'?: Deployservicev3Destination;
    'orgId'?: string;
    'campaignId'?: string;
    'status'?: V1OrderLineStatus;
    'state'?: V1State;
    'political'?: boolean;
    'prepay'?: boolean;
    'adType'?: Campaignservicev1AdType;
    'cpmKey'?: string;
    'locked'?: boolean;
    'paid'?: boolean;
    'orgName'?: string;
    'orgLogo'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "refId",
            "baseName": "ref_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "job_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "poId",
            "baseName": "po_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "deploymentDestination",
            "baseName": "deployment_destination",
            "type": "Deployservicev3Destination",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1OrderLineStatus",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "V1State",
            "format": ""
        },
        {
            "name": "political",
            "baseName": "political",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "prepay",
            "baseName": "prepay",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "adType",
            "baseName": "ad_type",
            "type": "Campaignservicev1AdType",
            "format": ""
        },
        {
            "name": "cpmKey",
            "baseName": "cpm_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "locked",
            "baseName": "locked",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "paid",
            "baseName": "paid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "orgName",
            "baseName": "org_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgLogo",
            "baseName": "org_logo",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineSearch.attributeTypeMap;
    }

    public constructor() {
    }
}

